.component {
  margin: 10px 0;
  padding: 15px;
  background-color: var(--ice-blue);
  border: solid 1px var(--very-light-pink);
  border-radius: 4px;
  /* The issue page is a fixed-height flex column — never let the panel squeeze the log list out */
  flex-shrink: 0;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 18px;
  font-weight: 500;
  color: var(--marine);
  cursor: pointer;
  user-select: none;
}

.toggle {
  margin-left: 6px;
  font-size: 13px;
  color: var(--brown-grey);
}

.analyzeButton {
  background-color: var(--marine);
  height: 29px;
  border: none;
  border-radius: 4px;
  padding: 0 15px;
  font-size: 12px;
  color: var(--fully-white);
  cursor: pointer;
}

.notice {
  margin-top: 8px;
  font-size: 13px;
  color: var(--mango);
}

.notice a {
  color: var(--tealish);
}

.loading {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  color: var(--brown-grey);
}

.result {
  margin-top: 10px;
  max-height: 45vh;
  overflow-y: auto;
}

.summary {
  font-size: 15px;
  font-weight: 500;
  color: var(--marine);
  margin-bottom: 5px;
}

.location {
  font-size: 13px;
  color: var(--black);
  margin-bottom: 5px;
}

.location a {
  color: var(--tealish);
}

.sectionTitle {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 500;
  color: var(--marine);
}



.fix {
  margin-top: 10px;
}

.fixPath {
  font-size: 13px;
  font-weight: 500;
  color: var(--marine);
  font-family: monospace;
}


.fixHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.error {
  margin-top: 10px;
  font-size: 13px;
  color: var(--lipstick);
}






.headerButtons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.prLink {
  font-size: 12px;
  color: var(--tealish);
}

.prCreating {
  font-size: 12px;
  font-style: italic;
  color: var(--brown-grey);
}
